import React from "react";
import { FriendlyErrorPage } from "./FriendlyErrorPage";
import { reportError } from "../reporting/reporter";

interface State { hasError: boolean; error?: Error; }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  constructor(props: { children: React.ReactNode }) { super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(error: Error): State { return { hasError: true, error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    void reportError({
      message: error.message,
      stack: (info.componentStack ? `${error.stack ?? ''}\n\nComponent stack:${info.componentStack}` : error.stack) ?? '',
    });
  }
  render() {
    if (this.state.hasError) {
      return <FriendlyErrorPage actionLabel="Reload page" onAction={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}
